
                $(document).ready(function(){
                  var mainImage =  $(".slider-irregular--p");
                  var mainWrap = mainImage.parents(".pokemon-wrap");
                  var mainNav = mainWrap.find(".slider-irregular-nav--p")

                  console.log(mainWrap);
                  console.log(mainNav);
                  
                 mainImage.slick({
                                slidesToShow:1,
                                slidesToScroll:1,
                                arrows:!1,
                                fade:!0,
                                asNavFor:mainNav,
                              autoplay:!0,autoplaySpeed:4e3,
                              waitForAnimate:false
                            }),
                            mainNav.slick({
                                slidesToShow:5,
                                slidesToScroll:1,
                                asNavFor:mainImage,
                                dots:!1,
                                centerMode:!1,
                                focusOnSelect:true,
                              waitForAnimate:false,
                                responsive:[{breakpoint:600,settings:{slidesToShow:3,slidesToScroll:3}}]
                            })
                });